import { render, staticRenderFns } from "./AuthPhone.vue?vue&type=template&id=14c0cd6c&scoped=true&"
import script from "./AuthPhone.vue?vue&type=script&lang=js&"
export * from "./AuthPhone.vue?vue&type=script&lang=js&"
import style0 from "./AuthPhone.vue?vue&type=style&index=0&id=14c0cd6c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c0cd6c",
  null
  
)

export default component.exports